import { Dropdown, Menu } from 'antd';
import _ from 'lodash';
import { UncontrolledTooltip } from 'reactstrap';
import { BulkAllActionIcon as bulkActionIcon } from '@/shared/ui';
import useBulkActionByCell from './useBulkActionByCell';
import './styles.scss';

export type BulkActionByCellProps = {
  isDisabled?: boolean;

  isTemplate?: boolean;

  keyRecoil: string;
};

/**
 * Renders the dropdown that applies a bulk action to all beats of the study rather than only those on the current page. Maps the bulkActionMenu entries from useBulkActionByCell into icon-and-label menu items and disables the trigger when the hook reports the action set is unavailable.
 *
 * @param props - Bulk action inputs forwarded to useBulkActionByCell, which derives the menu, click handler and disabled state.
 * @returns The all-beats bulk action dropdown with its trigger button and hover tooltip.
 */
const BulkActionByCell = ({
  isDisabled: isDisabledProp,
  isTemplate,
  keyRecoil,
}: BulkActionByCellProps) => {
  const { isDisabled, bulkActionMenu, onClickItem } = useBulkActionByCell({
    isDisabled: isDisabledProp,
    isTemplate,
    keyRecoil,
  });

  const items = _.map(bulkActionMenu.current, (x, i) => ({
    key: `beat-bulk-action-all-${i}`,
    label: (
      <div id={`bulk-action-radio-${i}`} className="bulk-action-radio">
        <div className="bulk-action-item --bulk-by-cell">
          <div className="item-label">
            <img src={x.icon} alt="icon" />
            <span>{x.label}</span>
          </div>
        </div>
      </div>
    ),
    value: x.value,
  }));

  return (
    <Dropdown
      trigger={['click']}
      disabled={isDisabled}
      overlay={
        <div className="bulk-action-menu-wrapper">
          <div className="bulk-action-menu-desc">Do an action to all beats:</div>
          <Menu onClick={onClickItem} className="bulk-action-menu" items={items} />
        </div>
      }
    >
      <div className="bulk-action-by-cell-wrapper">
        <button
          id="bulk-action-text--by-cell"
          disabled={isDisabled}
          className="bulk-action-text-by-cell"
        >
          <img src={bulkActionIcon} alt="bulk action icon" />
          All beats
        </button>
        <UncontrolledTooltip
          className="bulk-action-tooltip custom-tooltip"
          target="bulk-action-text--by-cell"
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          hideArrow
          trigger="hover"
        >
          <div className="beat-tooltip">All beats actions</div>
        </UncontrolledTooltip>
      </div>
    </Dropdown>
  );
};

export default BulkActionByCell;
